import styles from './Items.module.css';

import { memo } from 'react';

import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';

import Add from '@mui/icons-material/Add';
import ShoppingCart from '@mui/icons-material/ShoppingCart';

// MARK: header
export const ItemsHeader = memo(({ myList, count, cartCount, onNewItem, onOpenCart }) => {
    return (
        <div
            className={ styles.header }
            style={ {
                background: myList ? 'rgba(102, 165, 243, 0.15)' : 'rgba(255, 132, 0, 0.25)',
                borderBottom: count === 0 && 'none'
            } }>
            <span>Items: { count }</span>

            <Button onClick={ onNewItem } startIcon={ <Icon component={ Add } /> }>Add Item</Button>
                
            { myList && <div className={ styles.page }>
                <Button onClick={ onOpenCart }>
                    <Badge badgeContent={ cartCount } color="secondary">
                        <Icon component={ ShoppingCart } />
                    </Badge>
                </Button>
            </div> }
        </div>
    );
});

ItemsHeader.displayName = 'Items Header';